import {useEffect, useMemo, useState} from 'react';
import AddIcon from '@mui/icons-material/Add';

import {DocumentOnList, Documents} from '../documents';
import {
  addAttachmentsToPrevList,
  getAttachmentsOnList,
  getExcludedDocumentsIdsForJoining,
  serializeFromDocumentToAttachment,
  setAttachmentAsRemoved,
  setAttachmentsOrderNumbers
} from '../documents/helpers';
import './CreateNoteAttachments.scss';


const sortAttachmentsByOrderNumber = (attachment1, attachment2) => {
  const orderIndex1 = attachment1.orderIndex || 0;
  const orderIndex2 = attachment2.orderIndex || 0;
  if ([orderIndex1, orderIndex2].includes(0)) {
    return orderIndex2 - orderIndex1
  }
  return orderIndex1 - orderIndex2
};


export const CreateNoteAttachments = ({
  attachments,
  controlUuid,
  projectUuid,
  setAttachments
}) => {
  const [documentsOpen, setDocumentsOpen] = useState(false);

  useEffect(() => {
    // set initial order
    setAttachments(
      setAttachmentsOrderNumbers(
        attachments.sort(sortAttachmentsByOrderNumber)
      ),
      false  // it means this is the first set; in some cases it may be helpful
    );
  }, []);

  const attachmentsOnList = useMemo(() => {
    // sort initial data from backend
    return getAttachmentsOnList(
      attachments.sort(sortAttachmentsByOrderNumber));
  }, [attachments]);

  const excludedDocumentsIdsForJoining = useMemo(() => {
    return getExcludedDocumentsIdsForJoining(attachmentsOnList)
  }, [attachmentsOnList]);

  const [firstIndex, lastIndex] = useMemo(() => {
    if (!attachmentsOnList.length) { return [null, null] }
    return [
      attachmentsOnList[0].orderIndex,
      attachmentsOnList[attachmentsOnList.length - 1].orderIndex
    ]
  }, [attachmentsOnList]);

  function handleAdd(documentList) {
    const newAttachments = documentList.map(
      document => serializeFromDocumentToAttachment(document));
    setAttachments(
      setAttachmentsOrderNumbers(
        addAttachmentsToPrevList(attachments, newAttachments)
      ).sort(sortAttachmentsByOrderNumber)
    );

    setDocumentsOpen(false);
  }

  function handleRemove(documentId) {
    setAttachments(
      setAttachmentsOrderNumbers(
        setAttachmentAsRemoved(attachments, documentId, true)
      ).sort(sortAttachmentsByOrderNumber)
    );
    setDocumentsOpen(false);
  }

  function handleMove(oldIndex, newIndex) {
    let newOrder = [...attachments];
    newOrder.splice(
      newIndex < 0 ? newOrder.length + newIndex : newIndex,
      0,
      newOrder.splice(oldIndex, 1)[0]
    );
    setAttachments(setAttachmentsOrderNumbers(newOrder));
  }

  return (
    <>
      <div className='row add-files'>
        <div className='col-md-2 inputs-btn-list__btn-col'>
          <button className='btn save-btn' type='button' onClick={() => setDocumentsOpen(true)}>
            <AddIcon /><span className="sr-only">dodaj</span> PLIKI
          </button>
        </div>
      </div>
      {attachmentsOnList.map((attachment, index) =>
        <DocumentOnList
          canRemove
          document={attachment.document}
          key={attachment.document.id}  // attachment may not have id yet
          onlyRemoveFromList
          onRemoveDocument={handleRemove}
          // these are necessary if withMoveIcons
          index={attachment.orderIndex}
          isFirst={attachment.orderIndex === firstIndex}
          isLast={attachment.orderIndex === lastIndex}
          withMoveIcons={attachmentsOnList.length > 1}
          onMoveDown={() => handleMove(index, index + 1)}
          onMoveUp={() => handleMove(index, index - 1)}
        />
      )}
      {documentsOpen &&
        <Documents
            controlUuid={controlUuid}
            excludedDocumentsIdsForJoining={excludedDocumentsIdsForJoining}
            inPopup
            popUpTitle="Dodawanie pliku"
            projectUuid={projectUuid}
            onAddSuccess={handleAdd}
            saveAsDraft={true}
            onCancel={() => setDocumentsOpen(false)}
        />
      }
    </>
  )
};
